import React from 'react';
import { splitForHighlight } from '../../lib/highlight';

/** Renders `text` with search terms (and optionally sample types) highlighted. */
export const Highlight = ({ text, highlighter }) => {
  if (!highlighter || !text) return <>{text || ''}</>;
  return (
    <>
      {splitForHighlight(text, highlighter).map(({ text: part, match }, i) => {
        if (!match) return <React.Fragment key={i}>{part}</React.Fragment>;
        if (match.type === 'term') return <mark key={i} className="hl">{part}</mark>;
        return <span key={i} className={`sample-chip ${match.className}`}>{part}</span>;
      })}
    </>
  );
};
